export default __webpack_public_path__ + "static/studio-2-1-8c1456338be4042513d564ac1bc9aec5.jpg";